export default __webpack_public_path__ + "static/media/audio-4.0cc43640.wav";